var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-lg-none",attrs:{"href":"#ReservaAhora"}},[_c('div',{attrs:{"id":"ReservaAhora"}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"calendar3"}}),_c('p',{staticClass:"m-0"},[_vm._v("Reserva ahora")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }